import React, { FC } from 'react';
import Modal from 'components/modal';
import SendResponseModal from 'modules/static-pages/contact-page/components/send-response-modal/send-response-modal';
import classNames from 'classnames';

interface ContactFormModalProps {
    success: boolean;
    isMobile?: boolean;
    onCloseModal: () => void;
    message: {
        title: string;
        text: string;
    };
}

const ContactFormModal: FC<ContactFormModalProps> = ({
    onCloseModal,
    message,
    success,
    isMobile = false
}) => {
    return (
        <Modal
            showCloseIcon={false}
            center={true}
            isOpen={true}
            onClose={onCloseModal}
            shouldCloseOnOverlayClick={true}
            modalClassName={classNames(({
                'contact-status-modal': true,
                'contact-status-modal--mobile': isMobile
            }))}
        >
            <SendResponseModal
                message={message}
                success={success}
                onClose={onCloseModal}
            />
        </Modal>
    );
};

export default ContactFormModal;
